import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Joyride from 'react-joyride';
import { stopJoyride } from '../../store/modules/options';

const mapActionCreators = {
  stopJoyride,
};

const mapStateToProps = state => ({
  runJoyride: state.options.runJoyride,
});

class JoyRideDashboard extends React.Component {
  joyrideCallback = event => {
    if (event.action === 'close') {
      // this.props.stopJoyride();
    } else if (event.action === 'skip') {
      this.props.stopJoyride();
    }
  };

  render() {
    if (typeof this.props.runJoyride === 'undefined') {
      return null;
    }

    const joyrideSteps = [
      {
        title: 'Zentraler Einstieg: Der Erstellen Button',
        text:
          'Mit ihm können Sie an allen Stellen der Applikation Entitäten anlegen',
        selector: '.JoyrideStep1',
        position: 'bottom',
        type: 'hover',
        isFixed: true,
        style: {
          width: '29rem',
          hole: {
            borderRadius: '50%',
          },
          beacon: {
            offsetY: 0,
          },
        },
      },
      {
        title: 'Ihre Notizen',
        text:
          'Sie können diese Notizen wie Haftnotizen handhaben.<br>Diese sind privat und werden nur von Ihnen gesehen',
        selector: '.JoyrideStep2',
        position: 'top',
        type: 'hover',
        style: {
          width: '29rem',
          beacon: {
            offsetY: 0,
          },
        },
      },
    ];

    return (
      <Joyride
        ref="joyride-dashboard"
        steps={joyrideSteps}
        run={this.props.runJoyride} // or some other boolean for when you want to start it
        // debug={__DEV__}
        showSkipButton
        showStepsProgress
        type="continuous"
        callback={this.joyrideCallback}
        locale={{
          back: 'Zurück',
          close: 'Schließen',
          last: 'Schließen',
          next: 'Weiter',
          skip: 'Tutorial beenden',
        }}
      />
    );
  }
}
JoyRideDashboard.propTypes = {
  runJoyride: PropTypes.bool.isRequired,
  stopJoyride: PropTypes.func.isRequired,
};
JoyRideDashboard.defaultProps = {
  runJoyride: false,
};
export default connect(mapStateToProps, mapActionCreators)(JoyRideDashboard);



// WEBPACK FOOTER //
// ./src/components/JoyRideDashboard/JoyRideDashboard.js